// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AssetRefOut } from './assetRefOut.zod.ts';

export const legacyAssetsOutShapeDefault = `legacy`;

export const LegacyAssetsOut = zod.object({
  "carded": zod.array(zod.string()),
  "cited": zod.array(AssetRefOut),
  "mode": zod.union([zod.enum(['cards', 'retrieval']),zod.null()]),
  "retrieved": zod.array(AssetRefOut),
  "shape": zod.literal("legacy").default(legacyAssetsOutShapeDefault)
});

export type LegacyAssetsOut = zod.input<typeof LegacyAssetsOut>;
export type LegacyAssetsOutOutput = zod.output<typeof LegacyAssetsOut>;
